module.exports = "/static/assets/71b4643a023fda17a8d251985914a201.png";